import "./cta.component.css"
import { Link, useNavigate } from "react-router-dom"
import StrapiImageComponent from "../strapi-image/strapi-image.component"
import { daggerNavigate } from "../../utils/navigate.util"

const CtaComponent = (props) => {
  const { Heading, Copy, ButtonLabel, Media, PageLink, ExternalLink } = props
  const navigate = useNavigate()

  const handleOpenContact = () => {
    document.dispatchEvent(
      new CustomEvent("EVENTS.OPEN_CONTACT_FORM", {
        detail: { defaultSubject: "General Inquiry" },
      }),
    )
  }

  const handleInternalNav = (e) => {
    e.preventDefault()
    daggerNavigate(() => navigate(`/${PageLink.data.attributes.Slug}`))
  }

  const renderButton = () => {
    if (!ButtonLabel || (!PageLink?.data && !ExternalLink)) return null

    if (ExternalLink === "action:openContactForm") {
      return (
        <button className="dagger-outline-btn" onClick={handleOpenContact}>
          {ButtonLabel}
        </button>
      )
    }

    if (ExternalLink) {
      return (
        <a className="dagger-outline-btn" href={ExternalLink}>
          {ButtonLabel}
        </a>
      )
    }

    return (
      <Link
        className="dagger-outline-btn"
        to={`/${PageLink.data.attributes.Slug}`}
        onClick={handleInternalNav}
      >
        {ButtonLabel}
      </Link>
    )
  }

  return (
    <div className="dagger-cta">
      {Media && Media.data && (
        <div className="dagger-cta-media">
          <StrapiImageComponent
            attributes={Media.data.attributes}
            sizes="(max-width: 800px) 100vw, 50vw"
          />
        </div>
      )}
      <div className="dagger-cta-copy">
        <h2>{Heading}</h2>
        <div className="dagger-cta-desc">
          {Copy}
          {renderButton()}
        </div>
      </div>
    </div>
  )
}

export default CtaComponent
